/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.time', [])
    .factory('timeService', TimeService)
    .name;

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const MIN_INTERVAL = SECOND;
const MAX_INTERVAL = 365 * 20 * DAY;

const MIN_LIMIT = 10;
const AVG_LIMIT = 200;
const MAX_LIMIT = 500;

/*@ngInject*/
function TimeService(types) {

    var service = {
        defaultTimewindow: defaultTimewindow,
        avgAggregationLimit: function () {
            return AVG_LIMIT;
        },
        minIntervalLimit: minIntervalLimit,
        maxIntervalLimit: maxIntervalLimit
    };

    return service;

    function defaultTimewindow() {
        var currentTime = (new Date).getTime();
        var timewindow = {
            displayValue: "",
            selectedTab: 0,
            realtime: {
                interval: SECOND,
                timewindowMs: MINUTE, // 1 min by default,
            },
            history: {
                historyType: 0,
                interval: SECOND,
                timewindowMs: MINUTE, // 1 min by default
                fixedTimewindow: {
                    startTimeMs: currentTime - DAY, // 1 day by default
                    endTimeMs: currentTime,
                }
            },
            aggregation: {
                type: types.aggregation.avg.value,
                limit: AVG_LIMIT
            }
        };
        return timewindow;
    }

    function minIntervalLimit(timewindow) {
        var min = timewindow / MAX_LIMIT;
        return boundMinInterval(min);
    }

    function maxIntervalLimit(timewindow) {
        var max = timewindow / MIN_LIMIT;
        return boundMaxInterval(max);
    }


    function boundMinInterval(min) {
        return toBound(min, MIN_INTERVAL, MAX_INTERVAL, MIN_INTERVAL);
    }

    function boundMaxInterval(max) {
        return toBound(max, MIN_INTERVAL, MAX_INTERVAL, MAX_INTERVAL);
    }

    function toBound(value, min, max, defValue) {
        if (angular.isDefined(value)) {
            value = Math.max(value, min);
            value = Math.min(value, max);
            return value;
        } else {
            return defValue;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/api/time.service.js